var getMultiLangText = function (titleInfo, langKey) {
    if (langKey === void 0) { langKey = 'en'; }
    try {
        var titleObj = typeof titleInfo === 'object' ? titleInfo : JSON.parse(titleInfo);
        return titleObj[langKey];
    }
    catch (e) {
        return titleInfo;
    }
};
export { getMultiLangText };

//# sourceMappingURL=text.js.map
